<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const TelegramIcon = getIcon("TelegramIcon");
</script>

{#if typeof TelegramIcon === 'string'}
	<img src={TelegramIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof TelegramIcon === 'function'}
	<svelte:component this={TelegramIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
